import { getUploadFilePath } from '@/helpers/getUploadFilePath';
import { getAxiosWithAuth } from '@/lib/axios';
import type { RealtimeMessages } from '@/types/database/realtimeMessages';

type ConnectionInfo = Pick<
  RealtimeMessages[number],
  'associatedEntity' | 'entityId'
>;

export const createMessageContent = async (
  content: File | string,
  entity: string
) => {
  if (typeof content === 'string') {
    return {
      type: 'text',
      text: content,
    };
  }
  try {
    const path = await getUploadFilePath(content, entity);
    return {
      type: 'image',
      image: path,
    };
  } catch (error) {
    console.error(error);
    return;
  }
};

export const getSendMessage = (connectionInfo: ConnectionInfo) => {
  return async (message: File | string) => {
    const content = await createMessageContent(
      message,
      connectionInfo.associatedEntity
    );
    try {
      const axios = getAxiosWithAuth();
      await axios.post('/ezcon/api/realtimeMessages', {
        ...connectionInfo,
        content,
      });
    } catch (error) {
      console.error(error);
      throw new Error('請檢查網路環境或洽管理人員。');
    }
  };
};
